import React, { useEffect, useState } from "react";
import "./style.css";
import CustomCard from "../../../components/d-reusable/CustomCard";
import { Col, Form, Input, message, Row, Select } from "antd";
import { useSelector } from "react-redux";
import { getExaminarsSpecialties } from "../../../../components/https/projects-apis";
import CustomPrimaryButton from "../../../components/d-reusable/CustomPrimaryButton";
import CustomSpiner from "../../../components/d-reusable/CustomSpiner";
import {
  _userProfileData,
  updateProfile,
} from "../../../../components/https/settings/profileSettings";
import { errorRequestHandel } from "../../../../helper";

const { Option } = Select;

const MyProfileScreen = () => {
  const [form] = Form.useForm();
  const { dropdowns, countriesList = [] } = useSelector(
    (state) => state.general
  );
  const [specialities, setSpecialities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [userDetails, setUserDetails] = useState();

  useEffect(() => {
    getUser();
    getSpecialities();
  }, []);

  const getSpecialities = async () => {
    try {
      const response = await getExaminarsSpecialties();
      if (response.status === 200) {
        setSpecialities(response.data.data?.specialty);
      }
    } catch (error) {
      console.log("error");
    }
  };
  const getUser = async () => {
    try {
      setIsLoading(true);
      const response = await _userProfileData();
      if (response.status === 200) {
        setUserDetails(response.data.data);
        form.setFieldsValue({
          ...response.data.data,
          country: response?.data?.data?.country?.id,
          speciality: response?.data?.data?.speciality?.id,
        });
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const payload = {
        ...values,
        generated_by: "salem-ck0001",
      };
      const response = await updateProfile(payload);
      if (response.status === 200) {
        message.success("Profile has been updated successfully");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error: error });
    }
  };
  return (
    <div className="my_profile_screen_container">
      <CustomSpiner loading={isLoading} />
      <CustomCard>
        <div className="my_profile_screen_body">
          <p className="_heading">Edit Profile</p>
          <small>{userDetails?.email}</small>
          <div className="my_profile_screen_form">
            <Form layout="vertical" form={form} onFinish={onFinish}>
              <Row gutter={[10, 16]}>
                <Col md={8}>
                  <Form.Item
                    label="First Name"
                    name={"first_name"}
                    rules={[
                      { required: true, message: "This field is required" },
                    ]}
                  >
                    <Input placeholder="Full Name" />
                  </Form.Item>
                </Col>
                <Col md={8}>
                  <Form.Item
                    label="Last Name"
                    name={"last_name"}
                    rules={[
                      { required: true, message: "This field is required" },
                    ]}
                  >
                    <Input placeholder="Last Name" />
                  </Form.Item>
                </Col>
              </Row>
              {/* <Row gutter={[10, 16]}>
                <Col md={16}>
                  <Form.Item label="Email" name={"email"}>
                    <Input placeholder="Full Name" disabled />
                  </Form.Item>
                </Col>
              </Row> */}
              <Row gutter={[10, 16]}>
                <Col md={16}>
                  <Form.Item
                    label="Country"
                    name={"country"}
                    rules={[
                      { required: true, message: "This field is required" },
                    ]}
                  >
                    <Select
                      placeholder="Select"
                      showSearch
                      optionFilterProp="children" // Enables filtering based on the Option's text
                      filterOption={(input, option) =>
                        option?.children
                          ?.toLowerCase()
                          .includes(input.toLowerCase())
                      } // Custom filter function
                    >
                      {countriesList.map((item, index) => {
                        return (
                          <Option value={item.id} key={index}>
                            {item?.nice_name}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[10, 16]}>
                <Col md={8}>
                  <Form.Item
                    label="Speciality"
                    name={"speciality"}
                    rules={[
                      { required: true, message: "This field is required" },
                    ]}
                  >
                    <Select placeholder="Select">
                      {specialities?.map((item, index) => {
                        return (
                          <Option value={item.id} key={index}>
                            {item?.value}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col md={8}>
                  <Form.Item
                    label="License Number"
                    name={"license_number"}
                    rules={[
                      { required: true, message: "This field is required" },
                    ]}
                  >
                    <Input placeholder="License Number" />
                  </Form.Item>
                </Col>
              </Row>
              <br />
              <Row gutter={[10, 16]}>
                <Col md={8}>
                  <CustomPrimaryButton
                    title="Save Changes"
                    type={"submit"}
                    isLoading={loading}
                  />
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </CustomCard>
    </div>
  );
};

export default MyProfileScreen;
